import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  EditProductBulkApi,
  GetAllBrands,
  GetAllCategories,
  GetAllUnits,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddProduct.css";
import { Container, Col, Row } from "react-bootstrap";
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from "@syncfusion/ej2-react-grids";

const EditProductBulk = () => {
  const { currentColor, userID, userToken } = useStateContext();
  const [products, setProducts] = useState([]);
  const [UnitPrice, setUnitPrice] = useState(0);
  const [UnitPriceFlag, setUnitPriceFlag] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [DiscountFlag, setDiscountFlag] = useState(0);
  const [DiscountDiscFlag, setDiscountDiscFlag] = useState(0);
  const [Unit, setUnit] = useState("select");
  const [UnitFlag, setUnitFlag] = useState(0);
  const [Category, setCategory] = useState("select");
  const [CategoryFlag, setCategoryFlag] = useState(0);
  const [Brand, setBrand] = useState("select");
  const [BrandFlag, setBrandFlag] = useState(0);
  const [DisplayProduct, setDisplayProduct] = useState(0);
  const [DisplayProductFlag, setDisplayProductFlag] = useState(0);
  const [ActiveProduct, setActiveProduct] = useState(0);
  const [ActiveProductFlag, setActiveProductFlag] = useState(0);
  const [getunits, setUnits] = useState([]);
  const [getbrands, setbrands] = useState([]);
  const [getcategories, setCategories] = useState([]);
  const [loadBtn, setLoadBtn] = useState(false);

  const [ValError, setValError] = useState([]);

  const navigate = useNavigate();

  const customersGrid = [
    {
      headerText: "Product",
      field: "name",
      minWidth: "100",
      width: "135",
      maxWidth: "350",
      textAlign: "Center",
    },
  ];

  const handleChangeUnitPrice = (e) => {
    setUnitPrice(e.target.value);
  };

  const handleChangePriceFlag = () => {
    setUnitPriceFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeDiscount = (e) => {
    setDiscount(e.target.value);
  };

  const handleChangeDiscountFlag = () => {
    setDiscountFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeDiscountDiscFlag = () => {
    setDiscountDiscFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeUnit = (e) => {
    setUnit(e.target.value);
    if (e.target.value !== "select") {
      const updatedErrors = [...ValError];
      updatedErrors[4] = "";
      setValError(updatedErrors);
    }
  };

  const handleChangeUnitFlag = () => {
    setUnitFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeCategory = (e) => {
    setCategory(e.target.value);
    if (e.target.value !== "select") {
      const updatedErrors = [...ValError];
      updatedErrors[5] = "";
      setValError(updatedErrors);
    }
  };

  const handleChangeCategoryFlag = () => {
    setCategoryFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeBrand = (e) => {
    setBrand(e.target.value);
    if (e.target.value !== "select") {
      const updatedErrors = [...ValError];
      updatedErrors[6] = "";
      setValError(updatedErrors);
    }
  };

  const handleChangeBrandFlag = () => {
    setBrandFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeDisplay = (e) => {
    setDisplayProduct((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeDisplayFlag = () => {
    setDisplayProductFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeActive = (e) => {
    setActiveProduct((prev) => (prev === 0 ? 1 : 0));
  };

  const handleChangeActiveFlag = () => {
    setActiveProductFlag((prev) => (prev === 0 ? 1 : 0));
  };

  const handleBackClick = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      navigate("/Product");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);
    var resp = 0;
    try {
      setValError([]);
      const updatedErrors = [...ValError];

      if (UnitPriceFlag === 1 && UnitPrice === "") {
        updatedErrors[2] = "Please enter unit price.";
        setValError(updatedErrors);
        return;
      }
      if (UnitPriceFlag === 1 && UnitPrice < 0) {
        updatedErrors[2] = "Price must be greater than 0.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[2] = "";

      if (DiscountFlag === 1 && Discount === "") {
        updatedErrors[3] = "Please enter discount.";
        setValError(updatedErrors);
        return;
      }
      if (DiscountFlag === 1 && Discount < 0) {
        updatedErrors[3] = "Discount must be 0 or greater.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[3] = "";

      if (UnitFlag === 1 && (Unit === "select" || Unit === "Select Unit")) {
        updatedErrors[4] = "Please select unit.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[4] = "";

      if (BrandFlag === 1 && (Brand === "select" || Brand === "Select Brand")) {
        updatedErrors[5] = "Please select brand.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[5] = "";

      if (
        CategoryFlag === 1 &&
        (Category === "select" || Category === "Select Category")
      ) {
        updatedErrors[6] = "Please select category.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[6] = "";

      const unit_id = getunits.find((item) => item.names === Unit);
      const brand_id = getbrands.find((item) => item.name === Brand);
      const category_id = getcategories.find((item) => item.name === Category);
      const tableData = products.map((i) => i.product_id);

      const response = await EditProductBulkApi(
        UnitPriceFlag,
        UnitPrice,
        DiscountFlag,
        DiscountDiscFlag,
        Discount,
        UnitFlag,
        unit_id?.unit_id || 0,
        CategoryFlag,
        category_id?.category_id || 0,
        BrandFlag,
        brand_id?.brand_id || 0,
        DisplayProductFlag,
        DisplayProduct,
        ActiveProductFlag,
        ActiveProduct,
        tableData,
        userID,
        userToken,
      );
      resp = response.status;
      if (resp === 200) {
        alert("Products updated successfully!");
      } else {
        alert("Products failed to update.");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadBtn(false);
      if (resp === 200) {
        navigate("/Product");
      }
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (userID && userToken) {
        setProducts(JSON.parse(localStorage.getItem("editProductBulk")));
        GetAllUnits(userID, userToken)
          .then((resp) => {
            setUnits(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
        GetAllBrands(userID, userToken)
          .then((resp) => {
            setbrands(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
        GetAllCategories(userID, userToken)
          .then((resp) => {
            setCategories(resp.data || []);
          })
          .catch((err) => {
            console.log(err.message);
          });
      }
    }
    fetchData();
  }, [userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="EDIT PRODUCT BULK" />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row xs={1} sm={1} style={{ padding: "0" }}>
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">
                    <span>
                      Update Unit Price:{" "}
                      <input
                        type="checkbox"
                        checked={UnitPriceFlag === 1}
                        onChange={handleChangePriceFlag}
                      />
                    </span>
                  </label>
                  <input
                    type="number"
                    min="0"
                    // defaultValue={0}
                    step="1.00"
                    name="UnitPrice"
                    onChange={handleChangeUnitPrice}
                    value={UnitPrice}
                    placeholder="Price"
                    className="input"
                    disabled={UnitPriceFlag === 0}
                  />
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <span>
                    Update Discount:{" "}
                    <input
                      type="checkbox"
                      checked={DiscountFlag === 1}
                      onChange={handleChangeDiscountFlag}
                    />
                  </span>
                  <span className="pl-4">
                    %:{" "}
                    <input
                      type="checkbox"
                      checked={DiscountDiscFlag === 1}
                      onChange={handleChangeDiscountDiscFlag}
                      disabled={DiscountFlag === 0}
                    />
                  </span>
                  <input
                    type="number"
                    min="0"
                    // defaultValue={0}
                    step="1.00"
                    name="Discount"
                    onChange={handleChangeDiscount}
                    value={Discount}
                    placeholder="Discount"
                    className="input"
                    disabled={DiscountFlag === 0}
                  />
                  {ValError[3] && <p className="label-error">{ValError[3]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="UnitSelect">
                    <span>
                      Update Unit:{" "}
                      <input
                        type="checkbox"
                        checked={UnitFlag === 1}
                        onChange={handleChangeUnitFlag}
                      />
                    </span>
                  </label>
                  <select
                    id="UnitSelect"
                    className="select container-select"
                    value={Unit}
                    onChange={handleChangeUnit}
                    disabled={UnitFlag === 0}
                  >
                    <option defaultValue="select">Select Unit</option>
                    {getunits.map((item) => (
                      <option key={item.unit_id}>{item.names}</option>
                    ))}
                  </select>
                  {ValError[4] && <p className="label-error">{ValError[4]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="BrandSelect">
                    <span>
                      Update Brand:{" "}
                      <input
                        type="checkbox"
                        checked={BrandFlag === 1}
                        onChange={handleChangeBrandFlag}
                      />
                    </span>
                  </label>
                  <select
                    id="BrandSelect"
                    className="select container-select"
                    value={Brand}
                    onChange={handleChangeBrand}
                    disabled={BrandFlag === 0}
                  >
                    <option defaultValue="select">Select Brand</option>
                    {getbrands.map((item) => (
                      <option key={item.brand_id}>{item.name}</option>
                    ))}
                  </select>
                  {ValError[5] && <p className="label-error">{ValError[5]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label" htmlFor="CategorySelect">
                    <span>
                      Update Category:{" "}
                      <input
                        type="checkbox"
                        checked={CategoryFlag === 1}
                        onChange={handleChangeCategoryFlag}
                      />
                    </span>
                  </label>
                  <select
                    id="CategorySelect"
                    className="select container-select"
                    value={Category}
                    onChange={handleChangeCategory}
                    disabled={CategoryFlag === 0}
                  >
                    <option defaultValue="select">Select Category</option>
                    {getcategories.map((item) => (
                      <option key={item.category_id}>{item.name}</option>
                    ))}
                  </select>
                  {ValError[6] && <p className="label-error">{ValError[6]}</p>}
                </div>
              </div>
              <br />
              <label className="label">
                <span>
                  Update Active Product:{" "}
                  <input
                    type="checkbox"
                    checked={ActiveProductFlag === 1}
                    onChange={handleChangeActiveFlag}
                  />
                </span>
              </label>
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="ActiveProduct"
                  checked={ActiveProduct === 1}
                  onChange={handleChangeActive}
                  disabled={ActiveProductFlag === 0}
                />
                {` `} Active Product
              </label>
              <label className="label">
                <span>
                  Update Display Product:{" "}
                  <input
                    type="checkbox"
                    checked={DisplayProductFlag === 1}
                    onChange={handleChangeDisplayFlag}
                  />
                </span>
              </label>
              <label className="label-checkbox">
                <input
                  type="checkbox"
                  value="DisplayProduct"
                  checked={DisplayProduct === 1}
                  onChange={handleChangeDisplay}
                  disabled={DisplayProductFlag === 0}
                />
                {` `} Display Product
              </label>
              <br />
              <br />
            </Col>
            {/* <Col md={4} className="container-col">
              <br />
            </Col> */}
            <Col md={6} className="container-col">
              <GridComponent
                className="custom-grid1"
                dataSource={products}
                allowPaging={false}
                allowResizing
                rowHeight={18}
                height={480}
              >
                <ColumnsDirective>
                  {customersGrid.map((item, index) => (
                    <ColumnDirective key={index} {...item} />
                  ))}
                </ColumnsDirective>
              </GridComponent>
              <br />
              <br />
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Update All"
          borderRadius="10px"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditProductBulk;
